module.exports = __webpack_public_path__ + "assets/ac785acda09ca2dfa66768b8ef3dd2b9.mp3";